import 'swiper/css';
import 'swiper/css/bundle';
import '~/styles/layout/theme.scss';
import '~/assets/component-product-variant-picker.css';
import '~/assets/component-swatch-input.css';
import '~/assets/component-swatch.css';
import Alpine from 'alpinejs';
import Focus from '@alpinejs/focus';
import Swiper from 'swiper';
import { register } from 'swiper/element/bundle'

import { headerComponent } from '~js/components/header/header-component';
import { roxy } from '~js/components/roxy/roxy';
import { featuredCollection } from '~js/components/featured-collection-dsc/featured-collection-dsc';
import bannerCartApiHandler from '~js/components/banner-cart-api/banner-cart-api-handler';
import stickyCtaButton from '~js/components/sticky-cta-button/sticky-cta-button';
import subscriptionModal from '~js/components/subscription-modal/subscription-modal';
import dscCustomOrdergrooveUI from '~js/components/dsc-custom-ordergroove-ui/dsc-custom-ordergroove-ui';
import dscCustomOrdergrooveUIWithModal from '~js/components/dsc-custom-ordergroove-ui/dsc-custom-ordergroove-ui-with-modal';
import giftCardBalance from '~js/components/gift-card-balance/gift-card-balance';
import addToNextBoxButton from '~js/components/add-to-next-box-button/add-to-next-box-button';
import { collectionCard } from '~js/components/collection-card/collection-card';
import { compareHero } from '~js/components/page-hero-compare/page-hero-compare';
import goodBetterBest from '~js/components/good-better-best/good-better-best';
import pdpBundleKit from '~js/components/pdp-bundle-kit/pdp-bundle-kit';
import centeredCarousel from '~js/components/homepage/centered-carousel';
import reviewsSlider from '~js/components/product/reviews-slider';
import pageHeroProductOffers from '~js/components/page-hero-product-offers/page-hero-product-offers';
import pageVideoSlider from '~js/components/page-video-slider/page-video-slider';
import pageBundleHero from '~js/components/page-bundle-hero/page-bundle-hero';
import yourRoutineSlider from '~js/components/your-routine/your-routine-slider';
import accountNavigation from '~js/components/accounts/account-navigation';
import accountMainLayout from '~js/components/accounts/account-main-layout';
import accountModal from '~js/components/accounts/account-modal';
import datePicker from '~js/components/accounts/date-picker';
import { quickviewSwitcher } from '~js/components/quickview-switcher/quickview-switcher';
import accountTrySomethingNew from '~js/components/accounts/account-try-something-new';
import accountCancelationFlow from '~js/components/accounts/account-cancelation-flow';
import accountSwapProduct from '~js/components/accounts/account-swap-product';
import accountToast from '~js/components/accounts/account-toast';
import accountSwiper from '~js/components/accounts/account-swiper';
import accountConfirmationModal from '~js/components/accounts/account-confirmation-modal';
import pdpFullKit from '~js/components/pdp-full-kit/pdp-full-kit';
import ogActionModal from '~js/components/og-action-modal/og-action-modal';
import legacyDscCustomOrdergrooveUi from '~js/components/dsc-custom-ordergroove-ui/legacy-dsc-custom-ordergroove-ui';
import { discountEstimate, discountUtils } from '~/js/components/discount-estimate/discount-estimate';
import { SUBSCRIBER_CACHE_TTL_MS } from '~js/components/subscription-modal/ordergroove-api-helper';
import { clearSubscriberCache, ensureSubscriberHydrated } from '~js/components/subscription-modal/subscriber-cache';

const SUBSCRIPTION_CHECKOUT_INTENT_KEY = 'dsc_pending_subscription_checkout';

const isAccountPath = () => window.location.pathname.startsWith('/account');

const shouldClearSubscriberCacheForCheckoutIntent = () => {
  try {
    const raw = localStorage.getItem(SUBSCRIPTION_CHECKOUT_INTENT_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    const at = Number(parsed?.at);
    if (Number.isNaN(at)) {
      localStorage.removeItem(SUBSCRIPTION_CHECKOUT_INTENT_KEY);
      return false;
    }
    const isFresh = Date.now() - at <= SUBSCRIBER_CACHE_TTL_MS;
    if (!isFresh) {
      localStorage.removeItem(SUBSCRIPTION_CHECKOUT_INTENT_KEY);
      return false;
    }
    if (!isAccountPath()) {
      return false;
    }
    localStorage.removeItem(SUBSCRIPTION_CHECKOUT_INTENT_KEY);
    return true;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('[Theme] shouldClearSubscriberCacheForCheckoutIntent failed:', error);
    return false;
  }
};

window.theme = window.theme || {};
window.Alpine = Alpine;
window.theme.swiper = Swiper;
window.discountUtils = discountUtils;

// Register Alpine plugins
Alpine.plugin(Focus);

register();
const swiperReadyEvent = new Event("swiper:ready");

window.Alpine.data('bannerCartApi', bannerCartApiHandler);
window.Alpine.data('stickyCtaButton', stickyCtaButton);
window.Alpine.data('ordergroove', dscCustomOrdergrooveUI);
window.Alpine.data('ordergrooveWithModal', dscCustomOrdergrooveUIWithModal);
window.Alpine.data('modal', subscriptionModal);
window.Alpine.data('legacyDscCustomOrdergrooveUi', legacyDscCustomOrdergrooveUi);
window.Alpine.data('giftCardBalance', giftCardBalance);
window.Alpine.data('addToNextBoxButton', addToNextBoxButton);
window.Alpine.data('goodBetterBest', goodBetterBest);
window.Alpine.data('pdpBundleKit', pdpBundleKit);
window.Alpine.data('centeredCarousel', centeredCarousel);
window.Alpine.data('pageHeroProductOffers', pageHeroProductOffers);
window.Alpine.data('pageVideoSlider', pageVideoSlider);
window.Alpine.data('pageBundleHero', pageBundleHero);
window.Alpine.data('yourRoutineSlider', yourRoutineSlider);
window.Alpine.data('accountNavigation', accountNavigation);
window.Alpine.data('accountMainLayout', accountMainLayout);
window.Alpine.data('accountModal', accountModal);
window.Alpine.data('reviewsSlider', reviewsSlider);
window.Alpine.data('datePicker', datePicker);
window.Alpine.data('quickviewSwitcher', quickviewSwitcher);
window.Alpine.data('accountTrySomethingNew', accountTrySomethingNew);
window.Alpine.data('accountCancelationFlow', accountCancelationFlow);
window.Alpine.data('accountSwapProduct', accountSwapProduct);
window.Alpine.data('accountToast', accountToast);
window.Alpine.data('accountSwiper', accountSwiper);
window.Alpine.data('accountConfirmationModal', accountConfirmationModal);
window.Alpine.data('pdpFullKit', pdpFullKit);
window.Alpine.data('ogActionModal', ogActionModal);
window.Alpine.data('discountEstimate', discountEstimate);
window.Alpine.start();

if (window?.dsc?.customerId && window.dsc.customerId !== 'null') {
  if (shouldClearSubscriberCacheForCheckoutIntent()) {
    clearSubscriberCache('post-checkout-subscription-intent');
  }
  ensureSubscriberHydrated().catch(() => {
    // Best-effort warmup; surfaces also call ensureSubscriberHydrated on demand.
  });
} else {
  clearSubscriberCache('logged-out');
}

const initTheme = () => {
  roxy();
  document.dispatchEvent(swiperReadyEvent);
  collectionCard();
  featuredCollection();
  compareHero();
  headerComponent.init();
};

document.addEventListener('DOMContentLoaded', initTheme);
document.addEventListener('turbolinks:load', initTheme);
